import LayoutF from "./../components/LayoutF";
import imgnotFound from '../assets/imgs/404.svg'
import { Link } from "react-router-dom";

const NotFoundRoute = () => {
  return (
    <LayoutF>
      <div className="bg-auth">
        <div className="not-found-img min-vh-50 container d-flex align-items-center">
          <div className="row w-100">
            {/* Texte */}
            <div className="col-md-6 text-start d-flex flex-column justify-content-center">
              <h5 role="alert">
                Oh oh, la page que vous cherchez n’existe pas ...
              </h5>
              <p className="subtitle-s mt-4">
                Essaye d’utiliser notre moteur de recherche dans le menu du haut
                ou retourne à la page d’accueil.
              </p>
              <div className="mt-4">
                <Link className="cta-primary-m" to="/">
                  Retour à la page d’accueil
                </Link>
              </div>
            </div>

            {/* Image */}
            <div className="col-md-6 d-flex justify-content-center">
              <img
                src={imgnotFound}
                alt="Illustration page non trouvée"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </LayoutF>
  );
};

export default NotFoundRoute;
